import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AuthService} from './auth.service';
import {environment} from '../../environments/environment';
import {Invoice, User} from '../../models/business-objects';
import {firstValueFrom} from 'rxjs';
import {PagoEnLinea} from '../../models/payment';

@Injectable()
export class PaymentsService {
  UrlAPI: string = environment.apiURL;
  public currentUser: User;
  subscriptions = [];
  constructor(private http: HttpClient, private authService: AuthService) {
    this.subscriptions.push(authService.currentUser.subscribe( user => this.currentUser = user));
  }

  getPayments(): Promise<PagoEnLinea[]> {
    console.log('getting Payments for :');
    console.log(this.currentUser);
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/json');
    if ( this.currentUser.cliente != null)  {
      return firstValueFrom(this.http.post<any>(this.UrlAPI + environment.URL_PAYMENTS_LIST, { }, {headers} ));
    } else {
      return Promise.resolve([]);
    }
  }

}
